import {
  ACCOUNT_STATUS,
  AdminUser,
  IBrand,
  IBrandUser,
} from "@shared/lib/types";
import styles from "../styles.module.scss";
import { Space, Image, Tag } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { AgencyUser } from "@shared/lib/types/agency";

interface Props {
  agencyUser: AgencyUser;
  handleEditClick: () => void;
}

export function AgencyUserCard({ agencyUser, handleEditClick }: Props) {
  return (
    <div className={styles.card}>
      <Space
        style={{
          justifyContent: "space-between",
          width: "100%",
          alignItems: "start",
          marginBottom: 16,
        }}
      >
        <div>
          <div className={styles.name}>{agencyUser.name}</div>
          <div className={styles.role}>{agencyUser.role}</div>
        </div>
        <Tag
          color={
            agencyUser.accountStatus === ACCOUNT_STATUS.ACTIVE ? "green" : "red"
          }
        >
          {agencyUser.accountStatus}
        </Tag>
      </Space>

      <Space
        style={{
          justifyContent: "space-between",
          width: "100%",
          alignItems: "flex-end",
        }}
      >
        <div>
          <div className={styles.role}>
            {" "}
            Email : <u>{agencyUser.emailId}</u>
          </div>
          <div className={styles.role}>
            Phone : {agencyUser.countryCode}-{agencyUser.phoneNumber}
          </div>
        </div>

        <EditOutlined className={styles.icon} onClick={handleEditClick} />
      </Space>
    </div>
  );
}
